{
  "manifest": {
    "id": "generic-medieval-fantasy",
    "version": "0.1.0",
    "manifest_version": 1,
    "depends_on": [
      {
        "pack": "official-core",
        "version": "*"
      }
    ]
  },
  "entity_roots": [
    "location",
    "character",
    "faction",
    "event",
    "item",
    "lore"
  ],
  "predicates": [
    {
      "id": "pred_67049a3f-4c4a-4286-9334-91d2aa0fb8cb",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Class"
      }
    },
    {
      "id": "pred_b828071f-14b4-44fa-a619-1dac4b7f8c4f",
      "value_kind": [
        "number"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Level"
      }
    },
    {
      "id": "pred_25c4cd84-ed48-4f68-9f48-07dfd438b32b",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Alignment"
      }
    },
    {
      "id": "pred_d92bdf8e-d997-45ec-b19d-98ea58e3ca1c",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [
        "price"
      ],
      "label": {
        "en": "Currency value"
      }
    },
    {
      "id": "pred_f0bb78aa-6f9b-495c-9194-a08d60d2e7b7",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Patron deity"
      },
      "ref_root": "lore"
    }
  ],
  "traits": [
    {
      "id": "trait_b473939f-a94e-4096-826c-7e554027c282",
      "applies_to": [
        "character"
      ],
      "predicates": [
        "pred_67049a3f-4c4a-4286-9334-91d2aa0fb8cb",
        "pred_b828071f-14b4-44fa-a619-1dac4b7f8c4f",
        "pred_25c4cd84-ed48-4f68-9f48-07dfd438b32b"
      ],
      "label": {
        "en": "Adventurer"
      }
    },
    {
      "id": "trait_0ec1353a-69f9-40a3-91fd-f100a9eb70e2",
      "applies_to": [
        "item"
      ],
      "predicates": [
        "pred_d92bdf8e-d997-45ec-b19d-98ea58e3ca1c"
      ],
      "label": {
        "en": "Priced"
      }
    },
    {
      "id": "trait_d60b4bdd-4a8e-41b8-bd80-1b823083d5af",
      "applies_to": [
        "character",
        "faction"
      ],
      "predicates": [
        "pred_f0bb78aa-6f9b-495c-9194-a08d60d2e7b7"
      ],
      "label": {
        "en": "Worshipper"
      }
    }
  ]
}
